(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["account-navigation"] && !Shopify.designMode) return;
  try {
    (function() {
    var nav = document.getElementById('account-nav-mobile');
    if (!nav) return;

    var toggle = nav.querySelector('.account-nav-mobile__toggle');
    var links = nav.querySelectorAll('.account-nav-mobile__link');
    var iconDown = nav.querySelector('.account-nav-mobile__icon-down');
    var iconUp = nav.querySelector('.account-nav-mobile__icon-up');
    var open = false;

    if (toggle) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        open = !open;
        links.forEach(function(link) {
          link.classList.toggle('hidden', !open);
          link.classList.toggle('block', open);
        });
        iconDown.classList.toggle('hidden', open);
        iconUp.classList.toggle('hidden', !open);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    var previousItemCount = 0;
var cartDrawerNostoObserver = null;
var cartDrawerNostoInitQueued = false;

function queueCartDrawerNostoInit() {
  if (cartDrawerNostoInitQueued) return;
  cartDrawerNostoInitQueued = true;

  requestAnimationFrame(function() {
    cartDrawerNostoInitQueued = false;
    initCartDrawerNostoSwipers();
  });
}

function cartChange(key, qty) {
  return fetch(window.Gazman.routeRoot + 'cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty, sections: 'cart-drawer' }),
  })
  .then(function(res) { return res.json(); })
  .then(function(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    return cart;
  });
}

function getDrawer() {
  return document.getElementById('cart-drawer');
}

function isOpen() {
  var drawer = getDrawer();
  return drawer ? drawer.classList.contains('visible') : false;
}

function replaceCartDrawerHTML(target, html) {
  var template = document.createElement('template');
  template.innerHTML = html;
  target.innerHTML = '';
  target.appendChild(template.content.cloneNode(true));
}

var cartDrawerTrigger = null;

function setItemAddedLabelVisible(isVisible) {
  var drawer = getDrawer();
  if (!drawer) return;

  var labels = drawer.querySelectorAll('[data-item-added-label]');
  labels.forEach(function(label, index) {
    var shouldShow = isVisible && index === 0;
    label.classList.toggle('hidden', !shouldShow);
    label.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
  });
}

function openDrawer(showItemAddedLabel) {
  var drawer = getDrawer();
  if (!drawer) return;

  if (showItemAddedLabel) {
    setItemAddedLabelVisible(true);
  } else if (!isOpen()) {
    setItemAddedLabelVisible(false);
  }

  cartDrawerTrigger = document.activeElement;

  drawer.classList.remove('invisible');
  drawer.classList.add('transition-slow', 'visible');
  drawer.style.boxShadow = '-10px 0 10px rgba(0, 0, 0, 0.2)';
  drawer.setAttribute('aria-hidden', 'false');

  var inner = document.getElementById('cart-drawer-inner');
  if (inner) {
    inner.classList.remove('translate-x-full', 'transition-delay-none');
    inner.classList.add('translate-x-0', 'transition-delay');
    inner.style.transform = 'translateX(0)';
  }

  if (window.innerWidth <= 767) {
    document.body.style.overflow = 'hidden';
  }

  setTimeout(updateCartDrawerNostoSwipers, 250);

  // A11y: move focus into drawer
  var closeBtn = drawer.querySelector('[data-action="close-cart-drawer"]');
  if (closeBtn) {
    setTimeout(function() { closeBtn.focus(); }, 100);
  }
}

function closeDrawer() {
  var drawer = getDrawer();
  if (!drawer) return;

  setItemAddedLabelVisible(false);

  drawer.classList.remove('visible', 'transition-slow');
  drawer.classList.add('transition', 'invisible');
  drawer.style.boxShadow = 'none';
  drawer.setAttribute('aria-hidden', 'true');

  var inner = document.getElementById('cart-drawer-inner');
  if (inner) {
    inner.classList.remove('translate-x-0', 'transition-delay');
    inner.classList.add('translate-x-full', 'transition-delay-none');
    inner.style.transform = 'translateX(100%)';
  }

  document.body.style.overflow = '';

  // A11y: return focus to trigger
  if (cartDrawerTrigger && cartDrawerTrigger.focus) {
    cartDrawerTrigger.focus();
    cartDrawerTrigger = null;
  }
}

function renderCartFromSections(html) {
  var parser = new DOMParser();
  var doc = parser.parseFromString(html, 'text/html');

  var newItems = doc.getElementById('cart-drawer-items');
  var currentItems = document.getElementById('cart-drawer-items');
  if (newItems && currentItems) {
    currentItems.className = newItems.className;
    replaceCartDrawerHTML(currentItems, newItems.innerHTML);
  }

  var newFooter = doc.getElementById('cart-drawer-footer');
  var currentFooter = document.getElementById('cart-drawer-footer');
  if (newFooter && currentFooter) {
    replaceCartDrawerHTML(currentFooter, newFooter.innerHTML);
  }

  var newNosto = doc.getElementById('cart-drawer-nosto-slot');
  var currentNosto = document.getElementById('cart-drawer-nosto-slot');
  if (newNosto && currentNosto) {
    replaceCartDrawerHTML(currentNosto, newNosto.innerHTML);
  }

  var newMsg = doc.getElementById('cart-shipping-message');
  var currentMsg = document.getElementById('cart-shipping-message');
  if (newMsg && currentMsg) {
    replaceCartDrawerHTML(currentMsg, newMsg.innerHTML);
  }

  requestAnimationFrame(initCartDrawerNostoSwipers);
  requestAnimationFrame(watchCartDrawerNostoSwipers);
}

function initCartDrawerNostoSwipers() {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('#cart-drawer [data-nosto-cart-drawer-swiper]').forEach(function(swiperEl) {
    var slides = swiperEl.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    if (swiperEl._cartDrawerNostoSwiper) {
      swiperEl._cartDrawerNostoSwiper.update();
      return;
    }

    var placement = swiperEl.closest('[data-cart-nosto-placement]');
    if (!placement) return;

    var prevEl = placement.querySelector('[data-nosto-cart-drawer-prev]');
    var nextEl = placement.querySelector('[data-nosto-cart-drawer-next]');

    swiperEl._cartDrawerNostoSwiper = new Swiper(swiperEl, {
      slidesPerView: 2.5,
      slidesPerGroup: 1,
      spaceBetween: 5,
      speed: 350,
      loop: slides.length > 2,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
      breakpoints: {
        768: {
          slidesPerView: 2.5,
          spaceBetween: 16,
        },
      },
    });
  });
}

function watchCartDrawerNostoSwipers() {
  var slot = document.getElementById('cart-drawer-nosto-slot');
  if (!slot || cartDrawerNostoObserver) return;

  cartDrawerNostoObserver = new MutationObserver(function(mutations) {
    var shouldInit = mutations.some(function(mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function(node) {
        if (node.nodeType !== 1) return false;
        return node.matches('[data-nosto-cart-drawer-swiper], .swiper-slide, .nosto-cart-drawer-card') ||
          Boolean(node.querySelector && node.querySelector('[data-nosto-cart-drawer-swiper], .swiper-slide, .nosto-cart-drawer-card'));
      });
    });

    if (shouldInit) queueCartDrawerNostoInit();
  });

  cartDrawerNostoObserver.observe(slot, { childList: true, subtree: true });
}

function updateCartDrawerNostoSwipers() {
  document.querySelectorAll('#cart-drawer [data-nosto-cart-drawer-swiper]').forEach(function(swiperEl) {
    if (swiperEl._cartDrawerNostoSwiper) {
      swiperEl._cartDrawerNostoSwiper.update();
    }
  });
}

function fetchCartDrawerSection() {
  return fetch(window.Gazman.routeRoot + '?sections=cart-drawer')
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data['cart-drawer']) {
        renderCartFromSections(data['cart-drawer']);
      }
    });
}

function updateCartBadge(cart) {
  var badge = document.getElementById('header-cart-count');
  if (!badge) return;

  var count = (cart && cart.item_count) ? cart.item_count : 0;
  var countText = badge.querySelector('p');

  if (count > 0) {
    badge.style.display = 'flex';
    if (countText) countText.textContent = String(count);
  } else {
    badge.style.display = 'none';
  }
}

document.addEventListener('mousedown', function(e) {
  if (!isOpen()) return;
  var inner = document.getElementById('cart-drawer-inner');
  if (inner && !inner.contains(e.target)) {
    closeDrawer();
  }
});

document.addEventListener('click', function(e) {
  var target = e.target.closest('[data-action]');
  if (!target) return;

  var action = target.dataset.action;

  if (action === 'toggle-cart-drawer') {
    e.preventDefault();
    if (isOpen()) {
      closeDrawer();
    } else {
      openDrawer(false);
    }
  }

  if (action === 'close-cart-drawer') {
    e.preventDefault();
    closeDrawer();
  }

  if (action === 'cart-qty') {
    e.preventDefault();
    var key = target.dataset.key;
    var qty = parseInt(target.dataset.qty || '1', 10);
    if (key) {
      cartChange(key, qty);
    }
  }

  if (action === 'cart-remove') {
    e.preventDefault();
    var key = target.dataset.key;
    if (key) {
      cartChange(key, 0);
    }
  }
});

document.addEventListener('cart:updated', function(e) {
  var cart = e.detail;
  var showItemAddedLabel = Boolean(cart && cart._showItemAddedLabel);
  var hasCount = cart && typeof cart.item_count === 'number';

  if (cart.sections && cart.sections['cart-drawer']) {
    renderCartFromSections(cart.sections['cart-drawer']);
  } else {
    fetchCartDrawerSection();
  }

  setItemAddedLabelVisible(showItemAddedLabel);

  // The add-to-cart path skips /cart.js for speed, so item_count arrives later
  // via cart:reconcile. Only touch the badge here when the count is known.
  if (hasCount) updateCartBadge(cart);

  var cartUrl = document.getElementById('cart-drawer').dataset.cartUrl || '/cart';
  if (!window.location.pathname.includes(cartUrl)) {
    var shouldOpen = showItemAddedLabel || (hasCount && cart.item_count > previousItemCount);
    if (shouldOpen && !isOpen()) {
      openDrawer(showItemAddedLabel);
    }
  }
  if (hasCount) previousItemCount = cart.item_count;
});

// The add-to-cart path opens the drawer from the section response (which has no
// item_count); reconcile the header badge total once /cart.js resolves.
document.addEventListener('cart:reconcile', function(e) {
  var cart = e.detail;
  if (!cart) return;
  updateCartBadge(cart);
  if (typeof cart.item_count === 'number') previousItemCount = cart.item_count;
});

var initialCart = window.Gazman ? window.Gazman.cartData : null;
if (initialCart) {
  previousItemCount = initialCart.item_count || 0;
}

document.addEventListener('cart:open', function(e) {
  openDrawer(Boolean(e.detail && e.detail.showItemAddedLabel));
});

document.addEventListener('@nosto/DynamicCard/loaded', initCartDrawerNostoSwipers);
window.addEventListener('load', function() {
  initCartDrawerNostoSwipers();
  watchCartDrawerNostoSwipers();
});
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', watchCartDrawerNostoSwipers);
} else {
  watchCartDrawerNostoSwipers();
}

document.addEventListener('keydown', function(e) {
  var target = e.target.closest('[data-nosto-cart-drawer-prev], [data-nosto-cart-drawer-next]');
  if (!target) return;
  if (e.key !== 'Enter' && e.key !== ' ') return;

  e.preventDefault();
  target.click();
});

// A11y: Escape key closes drawer
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape' && isOpen()) {
    closeDrawer();
  }
});

// A11y: focus trap inside open drawer
document.addEventListener('keydown', function(e) {
  if (e.key !== 'Tab' || !isOpen()) return;
  var drawer = getDrawer();
  if (!drawer) return;
  var focusable = drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
  if (focusable.length === 0) return;
  var first = focusable[0];
  var last = focusable[focusable.length - 1];
  if (e.shiftKey) {
    if (document.activeElement === first) { e.preventDefault(); last.focus(); }
  } else {
    if (document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-navigation"] && !Shopify.designMode) return;
  try {
    (function() {
  var nav = document.getElementById('main-nav');
  if (!nav) return;

  var triggers = nav.querySelectorAll('[data-mega-menu-trigger]');

  function openMenu(trigger) {
    var section = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!section) return;
    trigger.setAttribute('aria-expanded', 'true');
    section.classList.add('opacity-100');
    section.classList.remove('opacity-0');
    var inner = section.querySelector('.border-t');
    if (inner) {
      inner.classList.remove('hidden', 'pointer-events-none');
      inner.classList.add('block', 'pointer-events-auto');
    }
  }

  function closeMenu(trigger) {
    var section = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!section) return;
    trigger.setAttribute('aria-expanded', 'false');
    section.classList.remove('opacity-100');
    section.classList.add('opacity-0');
    var inner = section.querySelector('.border-t');
    if (inner) {
      inner.classList.add('hidden', 'pointer-events-none');
      inner.classList.remove('block', 'pointer-events-auto');
    }
  }

  function closeAll() {
    triggers.forEach(function(t) { closeMenu(t); });
  }

  function isOpen(trigger) {
    return trigger.getAttribute('aria-expanded') === 'true';
  }

  // Keyboard: Enter/Space opens, Escape closes
  nav.addEventListener('keydown', function(e) {
    var trigger = e.target.closest('[data-mega-menu-trigger]');
    if (trigger) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (isOpen(trigger)) {
          closeMenu(trigger);
        } else {
          closeAll();
          openMenu(trigger);
        }
      }
    }
    if (e.key === 'Escape') {
      closeAll();
      if (document.activeElement && document.activeElement.closest('#main-nav')) {
        var activeTrigger = document.activeElement.closest('[data-mega-menu-trigger]');
        if (!activeTrigger) {
          // Focus was inside the dropdown; return to the open trigger
          triggers.forEach(function(t) { t.focus(); });
        }
      }
    }
  });

  // Focus entering trigger opens menu, leaving closes
  triggers.forEach(function(trigger) {
    trigger.addEventListener('focus', function() {
      closeAll();
      openMenu(trigger);
    });
  });

  // Close menus when focus leaves the nav entirely
  nav.addEventListener('focusout', function(e) {
    setTimeout(function() {
      if (!nav.contains(document.activeElement)) {
        closeAll();
      }
    }, 0);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["instant-search"] && !Shopify.designMode) return;
  try {
    (function() {
    var cfg = window.Gazman._instantSearch;
    if (!cfg) return;

    var container = document.querySelector('[data-instant-search]');
    var inner = document.querySelector('[data-instant-search-inner]');
    if (!container || !inner) return;

    var activeInput = null;
    var currentQuery = '';
    var lastResponse = null;
    var debounceTimer = null;
    var fetchController = null;
    var isVisible = false;

    // Market-aware storefront root (e.g. "/" on AU, "/en-nz/" on the NZ market)
    // so search/predictive requests and result links keep the active Markets subfolder.
    var ROOT = (window.Gazman && window.Gazman.routeRoot) || '/';

    // --- Utilities ---

    function esc(str) {
      if (!str) return '';
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    }

    function formatMoney(cents) {
      if (window.Gazman && window.Gazman.formatMoneyForMarket) {
        return window.Gazman.formatMoneyForMarket(cents, cfg.moneyFormat);
      }
      if (window.Gazman && window.Gazman.formatMoney) {
        return window.Gazman.formatMoney(cents, cfg.moneyFormat);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    // --- Recent searches (localStorage) ---

    var STORAGE_KEY = 'gazman_recent_searches';
    var MAX_RECENT = 5;

    function getRecentSearches() {
      try {
        var data = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        return Array.isArray(data) ? data.slice(0, MAX_RECENT) : [];
      } catch (e) { return []; }
    }

    function addRecentSearch(term) {
      if (!term || !term.trim()) return;
      term = term.trim();
      var searches = getRecentSearches().filter(function(s) {
        return s.toLowerCase() !== term.toLowerCase();
      });
      searches.unshift(term);
      if (searches.length > MAX_RECENT) searches = searches.slice(0, MAX_RECENT);
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(searches)); } catch(e) {}
    }

    function removeRecentSearch(term) {
      var searches = getRecentSearches().filter(function(s) {
        return s !== term;
      });
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(searches)); } catch(e) {}
    }

    // --- Show / Hide ---

    function show() {
      container.style.display = '';
      container.offsetHeight;
      container.classList.add('tis--visible');
      document.body.classList.add('tis-open');
      document.body.style.height = window.innerHeight + 'px';
      isVisible = true;
      positionDropdown();
    }

    function hide() {
      container.classList.remove('tis--visible');
      container.style.display = 'none';
      document.body.classList.remove('tis-open');
      document.body.style.height = '';
      isVisible = false;
    }

    function positionDropdown() {
      if (!activeInput) return;
      var anchor = activeInput.closest('.header-search') || activeInput;
      var rect = anchor.getBoundingClientRect();
      var isMobile = window.matchMedia('(max-width: 639px)').matches;
      container.style.position = 'fixed';
      if (isMobile) {
        // Mobile takeover: anchor below the search input, fill remaining viewport
        container.style.top = rect.bottom + 'px';
        container.style.left = '0';
        container.style.width = '100vw';
        container.style.height = (window.innerHeight - rect.bottom) + 'px';
      } else {
        container.style.top = (rect.bottom + 2) + 'px';
        container.style.left = rect.left + 'px';
        container.style.width = '474px';
        container.style.height = Math.min(700, Math.max(360, window.innerHeight - rect.bottom - 205)) + 'px';
      }
    }

    // --- Render: focus state (recent + popular) ---

    var cachedPopular = null;

    function renderFocusState() {
      var recent = getRecentSearches();

      if (cfg.useTagalys && tagalysReady && tagalysInstance && tagalysInstance.helpers) {
        // Render recent immediately, fetch popular async
        renderRecentAndPopular(recent, cachedPopular || []);

        if (cachedPopular === null) {
          tagalysInstance.helpers.getPopularSearches(MAX_RECENT).then(function(response) {
            cachedPopular = (response || []).map(function(item) { return item.query || ''; }).filter(Boolean);
            // Only re-render if still in focus state (no typed query)
            if (currentQuery.length < 2 && isVisible) {
              renderRecentAndPopular(getRecentSearches(), cachedPopular);
            }
          });
        }
      } else {
        // Shopify mode: just recent
        renderRecentAndPopular(recent, []);
      }
    }

    function renderRecentAndPopular(recent, popular) {
      // Dedupe: remove popular terms already in recent
      var recentLower = recent.map(function(s) { return s.toLowerCase(); });
      popular = (popular || []).filter(function(term) {
        return recentLower.indexOf(term.toLowerCase()) === -1;
      });

      if (!recent.length && !popular.length) {
        inner.innerHTML = '';
        hide();
        return;
      }

      var html = '';

      if (recent.length) {
        html += '<div class="tis__section">';
        html += '<div class="tis__heading">' + esc(cfg.labels.recentSearches) + '</div>';
        recent.forEach(function(term) {
          html += '<div class="tis__recent-row">';
          html += '<a href="' + ROOT + 'search?q=' + encodeURIComponent(term) + '" class="tis__item-link tis__recent-link" data-recent-term="' + esc(term) + '">' + esc(term) + '</a>';
          html += '<button class="tis__remove" data-remove-recent="' + esc(term) + '" aria-label="Remove" type="button">&times;</button>';
          html += '</div>';
        });
        html += '</div>';
      }

      if (popular.length) {
        html += '<div class="tis__section">';
        html += '<div class="tis__heading">' + esc(cfg.labels.popularSearches) + '</div>';
        popular.forEach(function(term) {
          html += '<a href="' + ROOT + 'search?q=' + encodeURIComponent(term) + '" class="tis__item-link" data-suggestion-query="' + esc(term) + '">' + esc(term) + '</a>';
        });
        html += '</div>';
      }

      inner.innerHTML = html;
      show();
    }

    // --- Render: search results (normalized data) ---
    // data shape: { suggestions[], collections[], products[], totalCount }
    // suggestion: { text, styledText?, url }
    // collection: { title, url }
    // product:    { title, url, image, priceCents, comparePriceCents }

    function renderResults(data) {
      lastResponse = data;
      var suggestions = (data.suggestions || []).slice(0, 5);
      var collections = (data.collections || []).slice(0, 5);
      var products = (data.products || []).slice(0, 6);
      var totalCount = data.totalCount || 0;

      var html = '';

      // Suggestions
      if (suggestions.length) {
        html += '<div class="tis__section">';
        html += '<div class="tis__heading">' + esc(cfg.labels.suggestions) + '</div>';
        suggestions.forEach(function(item) {
          html += '<a href="' + esc(item.url) + '" class="tis__item-link" data-suggestion-query="' + esc(item.text) + '">' + (item.styledText || esc(item.text)) + '</a>';
        });
        html += '</div>';
      }

      // Collections (hidden on mobile via CSS to match live)
      if (collections.length) {
        html += '<div class="tis__section tis__section--collections">';
        html += '<div class="tis__heading">' + esc(cfg.labels.collections) + '</div>';
        collections.forEach(function(item) {
          html += '<a href="' + esc(item.url) + '" class="tis__item-link" data-suggestion-query="' + esc(item.title) + '">' + esc(item.title) + '</a>';
        });
        html += '</div>';
      }

      // Products
      if (products.length) {
        html += '<div class="tis__section">';
        html += '<div class="tis__heading">' + esc(cfg.labels.products) + '</div>';
        html += '<div class="tis__product-grid">';
        products.forEach(function(p) {
          var imgSrc = p.image || '';
          if (imgSrc && imgSrc.indexOf('?') === -1) imgSrc += '?width=120';
          if (imgSrc && imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
          var onSale = p.comparePriceCents > p.priceCents && p.comparePriceCents > 0;

          html += '<a href="' + esc(p.url) + '" class="tis__product">';
          html += '<div class="tis__product-img-wrap">';
          if (imgSrc) {
            html += '<img class="tis__product-img" src="' + esc(imgSrc) + '" width="60" height="72" loading="lazy" alt="' + esc(p.title) + '" />';
          }
          html += '</div>';
          html += '<div class="tis__product-info">';
          html += '<p class="tis__product-title">' + esc(p.title) + '</p>';
          html += '<div class="tis__product-price">';
          if (onSale) {
            html += '<span class="tis__product-was">' + formatMoney(p.comparePriceCents) + '</span>';
          }
          html += '<span class="' + (onSale ? 'tis__product-now' : '') + '">' + formatMoney(p.priceCents) + '</span>';
          html += '</div>';
          html += '</div>';
          html += '</a>';
        });
        html += '</div>';
        html += '</div>';
      }

      // CTA
      var q = currentQuery;
      var ctaLabel;
      if (totalCount > 0) {
        ctaLabel = cfg.labels.viewResults
          .replace('[count]', totalCount)
          .replace('[query]', esc(q));
      } else {
        ctaLabel = cfg.labels.viewResultsNoCount.replace('[query]', esc(q));
      }

      html += '<div class="tis__cta">';
      html += '<a href="' + ROOT + 'search?q=' + encodeURIComponent(q) + '" class="tis__cta-btn text-sm" data-cta-search>' + ctaLabel + '</a>';
      html += '</div>';

      inner.innerHTML = html;
      show();
    }

    // =====================================================================
    // API: Shopify Predictive Search
    // =====================================================================

    function callShopifySearch(query) {
      if (fetchController) fetchController.abort();
      fetchController = new AbortController();

      var url = ROOT + 'search/suggest.json'
        + '?q=' + encodeURIComponent(query)
        + '&resources[type]=product,collection,query'
        + '&resources[limit]=6'
        + '&resources[limit_scope]=each'
        + '&resources[options][unavailable_products]=hide';

      fetch(url, { signal: fetchController.signal })
        .then(function(res) {
          if (!res.ok) throw new Error(res.status);
          return res.json();
        })
        .then(function(json) {
          var r = json.resources && json.resources.results;
          if (!r) { hide(); return; }
          renderResults(normalizeShopify(r));
        })
        .catch(function(err) {
          if (err.name === 'AbortError') return;
          hide();
        });
    }

    function normalizeShopify(r) {
      var suggestions = (r.queries || []).map(function(q) {
        return { text: q.text || '', styledText: q.styled_text || null, url: q.url || (ROOT + 'search?q=' + encodeURIComponent(q.text || '')) };
      });

      var collections = (r.collections || []).map(function(c) {
        return { title: c.title || '', url: c.url || (ROOT + 'collections/' + c.handle) };
      });

      var products = (r.products || []).map(function(p) {
        var price = parseInt(p.price, 10) || 0;
        var compare = parseInt(p.compare_at_price_max || p.compare_at_price_min || '0', 10);
        return {
          title: p.title || '',
          url: p.url || (ROOT + 'products/' + p.handle),
          image: p.image || '',
          priceCents: price,
          comparePriceCents: compare
        };
      });

      return { suggestions: suggestions, collections: collections, products: products, totalCount: 0 };
    }

    // =====================================================================
    // API: Tagalys Search Suggestions (SDK APIConnector)
    // Docs: Tagalys.APIConnector.SearchSuggestions.new
    // Response: { sections: { collections: { items }, products: { items, total_count } } }
    // =====================================================================

    var tagalysInstance = null;
    var tagalysReady = false;
    var pendingTagalysQuery = null;

    function initTagalys() {
      if (!window.Gazman || !window.Gazman.onTagalysReady) return;
      window.Gazman.onTagalysReady(function() {
        var connector = Tagalys.APIConnector;
        if (!connector || !connector.SearchSuggestions) return;

        tagalysInstance = connector.SearchSuggestions.new({
          params: {
            sections: {
              popular_searches: { count: 5 },
              collections: { count: 5 },
              products: {
                include: ['total_count', 'items'],
                count: 6
              }
            }
          },
          onSuccess: function(response, helpers) {
            renderResults(normalizeTagalys(response));
          },
          onFailure: function() {
            hide();
          }
        });

        tagalysReady = true;

        // Fire any query that came in before SDK was ready
        if (pendingTagalysQuery) {
          var q = pendingTagalysQuery;
          pendingTagalysQuery = null;
          tagalysInstance.helpers.updateQuery(q, 300);
        }
      });
    }

    function callTagalysSearch(query) {
      if (!tagalysReady || !tagalysInstance) {
        pendingTagalysQuery = query;
        return;
      }
      tagalysInstance.helpers.updateQuery(query, 300);
    }

    function normalizeTagalys(response) {
      var suggestions = [];
      var collections = [];
      var products = [];
      var totalCount = 0;
      var sections = response.sections || {};

      // Collections section
      if (sections.collections && sections.collections.items) {
        sections.collections.items.forEach(function(item) {
          collections.push({
            title: item.title || item.displayString || '',
            url: item.link || ''
          });
        });
      }

      // Any other non-product sections are text suggestions
      Object.keys(sections).forEach(function(key) {
        if (key === 'products' || key === 'collections') return;
        var section = sections[key];
        if (!section.items) return;
        section.items.forEach(function(item) {
          var text = item.displayString || item.title || item.query || '';
          if (!text) return;
          var url = item.link || '';
          if (!url && item.queryString) {
            url = ROOT + 'search?' + item.queryString;
          }
          suggestions.push({ text: text, styledText: null, url: url || (ROOT + 'search?q=' + encodeURIComponent(text)) });
        });
      });

      // Products section
      if (sections.products) {
        totalCount = sections.products.total_count || 0;
        (sections.products.items || []).forEach(function(p) {
          var imgSrc = '';
          if (p.featured_image && p.featured_image.src) imgSrc = p.featured_image.src;
          products.push({
            title: p.title || '',
            url: ROOT + 'products/' + p.handle,
            image: imgSrc,
            // Tagalys returns prices in dollars, formatMoney expects cents
            priceCents: Math.round((p.price || 0) * 100),
            comparePriceCents: Math.round((p.compare_at_price || 0) * 100)
          });
        });
      }

      return { suggestions: suggestions, collections: collections, products: products, totalCount: totalCount };
    }

    // =====================================================================
    // Dispatcher
    // =====================================================================

    function callSearch(query) {
      if (cfg.useTagalys) {
        callTagalysSearch(query);
      } else {
        callShopifySearch(query);
      }
    }

    // --- Event handling ---

    function onFocus(e) {
      activeInput = e.target;
      var val = activeInput.value.trim();
      if (val.length >= 2) {
        if (lastResponse && currentQuery === val) {
          renderResults(lastResponse);
        } else {
          currentQuery = val;
          callSearch(val);
        }
      } else {
        renderFocusState();
      }
    }

    function onInput(e) {
      var val = e.target.value.trim();
      activeInput = e.target;
      currentQuery = val;

      if (debounceTimer) clearTimeout(debounceTimer);

      if (val.length < 2) {
        lastResponse = null;
        renderFocusState();
        return;
      }

      if (cfg.useTagalys) {
        // Tagalys SDK debounces internally via updateQuery's second param
        callSearch(val);
      } else {
        debounceTimer = setTimeout(function() {
          callSearch(val);
        }, 200);
      }
    }

    function onFormSubmit(e) {
      var input = e.target.querySelector('input[name="q"]');
      if (input && input.value.trim()) {
        addRecentSearch(input.value.trim());
      }
      hide();
    }

    function bindInput(input) {
      if (!input) return;
      input.addEventListener('focus', onFocus);
      input.addEventListener('input', onInput);

      var form = input.closest('form');
      if (form) {
        form.addEventListener('submit', onFormSubmit);
      }
    }

    // --- Event delegation on container ---

    container.addEventListener('click', function(e) {
      var removeBtn = e.target.closest('[data-remove-recent]');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        removeRecentSearch(removeBtn.getAttribute('data-remove-recent'));
        renderFocusState();
        if (activeInput) activeInput.focus();
        return;
      }

      var recentLink = e.target.closest('[data-recent-term]');
      if (recentLink) {
        addRecentSearch(recentLink.getAttribute('data-recent-term'));
        return;
      }

      var suggestionLink = e.target.closest('[data-suggestion-query]');
      if (suggestionLink) {
        addRecentSearch(suggestionLink.getAttribute('data-suggestion-query'));
        return;
      }

      var ctaBtn = e.target.closest('[data-cta-search]');
      if (ctaBtn) {
        addRecentSearch(currentQuery);
        return;
      }
    });

    // --- Global listeners ---

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isVisible) {
        hide();
        if (activeInput) activeInput.blur();
      }
    });

    document.addEventListener('click', function(e) {
      if (!isVisible) return;
      if (container.contains(e.target)) return;
      var desktopInput = document.getElementById('header-search-input');
      var mobileInput = document.getElementById('mobile-search-input');
      if (desktopInput && (desktopInput === e.target || desktopInput.contains(e.target))) return;
      if (mobileInput && (mobileInput === e.target || mobileInput.contains(e.target))) return;
      hide();
    });

    window.addEventListener('scroll', function() {
      if (isVisible) positionDropdown();
    }, { passive: true });

    window.addEventListener('resize', function() {
      if (isVisible) positionDropdown();
    }, { passive: true });

    // --- Init ---

    function init() {
      bindInput(document.getElementById('header-search-input'));
      bindInput(document.getElementById('mobile-search-input'));
      if (cfg.useTagalys) initTagalys();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-navigation"] && !Shopify.designMode) return;
  try {
    (function() {
  function init() {
    var mobileNav = document.getElementById('mobile-nav');
    if (!mobileNav) return;

    var mobileNavTrigger = null;

    function setToggleExpanded(expanded) {
      var toggles = document.querySelectorAll('[data-action="toggle-mobile-nav"]');
      toggles.forEach(function(t) { t.setAttribute('aria-expanded', String(expanded)); });
    }

    function openMobileNav() {
      mobileNavTrigger = document.activeElement;
      mobileNav.classList.remove('invisible');
      mobileNav.classList.add('transition-slow', 'visible');
      mobileNav.setAttribute('aria-hidden', 'false');
      setToggleExpanded(true);

      var bg = mobileNav.querySelector('.bg-dark');
      if (bg) {
        bg.classList.remove('opacity-0');
        bg.classList.add('transition-slow', 'opacity-75');
      }

      var panel = mobileNav.querySelector('.relative.h-full');
      if (panel) {
        panel.classList.remove('translate-x:-100', 'transition-delay-none');
        panel.classList.add('translate-x:0', 'transition-delay');
      }

      document.body.style.overflow = 'hidden';

      // A11y: move focus into nav
      var closeBtn = mobileNav.querySelector('[data-action="close-mobile-nav"]');
      if (closeBtn) { setTimeout(function() { closeBtn.focus(); }, 100); }
    }

    function closeMobileNav() {
      mobileNav.classList.remove('visible', 'transition-slow');
      mobileNav.classList.add('transition', 'invisible');
      mobileNav.setAttribute('aria-hidden', 'true');
      setToggleExpanded(false);

      var bg = mobileNav.querySelector('.bg-dark');
      if (bg) {
        bg.classList.remove('transition-slow', 'opacity-75');
        bg.classList.add('transition', 'opacity-0');
      }

      var panel = mobileNav.querySelector('.relative.h-full');
      if (panel) {
        panel.classList.remove('translate-x:0', 'transition-delay');
        panel.classList.add('translate-x:-100', 'transition-delay-none');
      }

      document.body.style.overflow = '';

      // A11y: return focus
      if (mobileNavTrigger && mobileNavTrigger.focus) {
        mobileNavTrigger.focus();
        mobileNavTrigger = null;
      }
    }

    // A11y: Escape closes mobile nav
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !mobileNav.classList.contains('invisible')) {
        closeMobileNav();
      }
    });

    // A11y: focus trap
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab' || mobileNav.classList.contains('invisible')) return;
      var focusable = mobileNav.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    document.addEventListener('click', function(e) {
      var target = e.target.closest('[data-action]');
      if (!target) return;

      var action = target.dataset.action;

      if (action === 'toggle-mobile-nav') {
        e.preventDefault();
        if (mobileNav.classList.contains('invisible')) {
          openMobileNav();
        } else {
          closeMobileNav();
        }
      }

      if (action === 'close-mobile-nav') {
        e.preventDefault();
        closeMobileNav();
      }

      if (action === 'toggle-accordion') {
        e.preventDefault();
        var handle = target.dataset.handle;
        if (!handle) return;

        var submenu = mobileNav.querySelector('[data-accordion="' + handle + '"]');
        if (!submenu) return;

        var isOpen = submenu.classList.contains('max-h-none');

        mobileNav.querySelectorAll('[data-accordion]').forEach(function(el) {
          el.classList.remove('max-h-none', 'visible', 'opacity-100', 'transition-fast');
          el.classList.add('max-h-0', 'invisible', 'opacity-0');
        });
        mobileNav.querySelectorAll('.accordion-chevron').forEach(function(el) {
          el.classList.remove('rotate:180');
          el.classList.add('rotate:0');
        });
        mobileNav.querySelectorAll('[data-action="toggle-accordion"]').forEach(function(el) {
          el.classList.remove('text-brand', 'border-brand');
          el.classList.add('text-primary', 'border-grey');
          el.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          submenu.classList.remove('max-h-0', 'invisible', 'opacity-0');
          submenu.classList.add('max-h-none', 'visible', 'opacity-100', 'transition-fast');

          var chevron = target.querySelector('.accordion-chevron');
          if (chevron) {
            chevron.classList.remove('rotate:0');
            chevron.classList.add('rotate:180');
          }

          target.classList.remove('text-primary', 'border-grey');
          target.classList.add('text-brand', 'border-brand');
          target.setAttribute('aria-expanded', 'true');
        }
      }

      if (action === 'close-dropdown') {
        var dropdown = target.closest('section');
        if (dropdown) {
          dropdown.classList.add('hidden');
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nosto-placements-shared"] && !Shopify.designMode) return;
  try {
    // Tagalys search visibility
  function applyTagalysSearchVisibility(placementItemEl, detail) {
    const { noQuery, empty } = detail || {};
    placementItemEl.classList.toggle('nosto-placements__item--tagalys-hidden', !noQuery && !empty);
  }

  window.addEventListener('tagalys:search-results', (e) => {
    document.querySelectorAll('[data-nosto-tagalys-search-visibility]').forEach((el) => {
      applyTagalysSearchVisibility(el, e.detail);
    });
  });

  // Splide carousel management
  (function () {
    function splideOptions(perPage, totalSlides) {
      const slides = Math.max(1, Math.min(6, perPage));
      return {
        type: totalSlides > slides ? 'loop' : 'slide',
        perPage: slides,
        perMove: 1,
        gap: '0px',
        arrows: true,
        pagination: false,
        speed: 400,
        breakpoints: {
          // <1024px: hide desktop arrows, show pagination dots instead
          1023: { perPage: 2, arrows: false, pagination: true },
          // <=767px: 1 card with peek, dots stay
          767:  { perPage: 1, padding: { right: '35%' }, gap: '8px', arrows: false, pagination: true },
        },
      };
    }

    function markCarouselReady(carouselEl) {
      const shell = carouselEl.closest('[data-nosto-carousel-shell]');
      if (shell) shell.classList.add('is-nosto-carousel-ready');
    }

    function hidePlacementWithoutProducts(shell) {
      const item = shell.closest('.nosto-placements__item');
      if (item) item.classList.add('nosto-placements__item--empty');
      const cartPlacement = shell.closest('[data-nosto-cart-page-placement]');
      if (cartPlacement) cartPlacement.classList.add('nosto-placements--empty');
      shell.classList.add('is-nosto-carousel-ready');
    }

    function bindCampaignSettled(shell) {
      if (shell._nostoCampaignLoadBound) return;
      const campaign = shell.querySelector('nosto-campaign');
      if (!campaign) return;
      shell._nostoCampaignLoadBound = true;

      function onSettled() {
        if (shell.classList.contains('is-nosto-carousel-ready')) return;
        if (!campaign.querySelector('[data-nosto-products-slider]')) {
          hidePlacementWithoutProducts(shell);
        }
      }

      let hasBeenLoading = campaign.hasAttribute('loading');
      const obs = new MutationObserver(() => {
        if (campaign.hasAttribute('loading')) { hasBeenLoading = true; return; }
        if (hasBeenLoading) { obs.disconnect(); onSettled(); }
      });
      obs.observe(campaign, { attributes: true, attributeFilter: ['loading'] });

      if (hasBeenLoading && !campaign.hasAttribute('loading')) {
        requestAnimationFrame(onSettled);
      }
    }

    const ARROW_SPAN_CLASSES = 'block p-2 text-brand transition-fast visible opacity-100';
    const ARROW_LEFT_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 10" width="18">'
      + '<path fill="currentColor" fill-rule="evenodd" d="M2.216 4.5h12.789c.273 0 .495.224.495.5s-.222.5-.495.5H2.215l3.138 3.139a.506.506 0 01-.357.861.506.506 0 01-.357-.147L.647 5.356a.505.505 0 010-.712L4.64.648a.505.505 0 11.714.713L2.216 4.5z"></path>'
      + '</svg>';
    const ARROW_RIGHT_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 10" width="18">'
      + '<path fill="currentColor" fill-rule="evenodd" d="M13.784 4.5H.995C.722 4.5.5 4.724.5 5s.222.5.495.5h12.79l-3.138 3.139a.506.506 0 00.357.861.506.506 0 00.357-.147l3.992-3.997a.505.505 0 000-.712L11.36.648a.505.505 0 10-.714.713L13.784 4.5z"></path>'
      + '</svg>';

    function customiseArrowMarkup(carouselEl) {
      const prev = carouselEl.querySelector('.splide__arrow--prev');
      const next = carouselEl.querySelector('.splide__arrow--next');
      if (prev) {
        prev.innerHTML = '<span class="' + ARROW_SPAN_CLASSES + '">' + ARROW_LEFT_SVG + '</span>';
      }
      if (next) {
        next.innerHTML = '<span class="' + ARROW_SPAN_CLASSES + '">' + ARROW_RIGHT_SVG + '</span>';
      }
    }

    let nostoWishlistProducts = [];

    function getWishlistButtonProductData(btn) {
      const productId = Number(btn.dataset.productId);
      const variantId = Number(btn.dataset.variantId) || productId;
      return { productId: productId, variantId: variantId };
    }

    function setWishlistButtonState(btn, isInWishlist) {
      const starEmpty = btn.querySelector('.js-wishlist-star');
      const starFilled = btn.querySelector('.js-wishlist-star-filled');
      btn.classList.toggle('swym-added', isInWishlist);
      if (starEmpty && starFilled) {
        starEmpty.classList.toggle('hidden', isInWishlist);
        starFilled.classList.toggle('hidden', !isInWishlist);
      }
    }

    function isWishlistButtonAdded(btn) {
      const ids = getWishlistButtonProductData(btn);
      if (btn.classList.contains('swym-added')) return true;
      return nostoWishlistProducts.some((item) => (
        item.epi === ids.variantId || item.epi === ids.productId || item.empi === ids.productId
      ));
    }

    function syncNostoWishlistButtons() {
      document.querySelectorAll('.nosto-placements [data-action="wishlist-toggle"]').forEach((btn) => {
        setWishlistButtonState(btn, isWishlistButtonAdded(btn));
      });
    }

    function fetchNostoWishlist() {
      const swat = window._swat;
      if (!swat || typeof swat.fetch !== 'function') return;
      swat.fetch((products) => {
        nostoWishlistProducts = Array.isArray(products) ? products : [];
        syncNostoWishlistButtons();
      });
    }

    function runSwymActionButtonInitializers() {
      const swat = window._swat;
      if (!swat) return false;

      try {
        if (typeof swat.initializeActionButtons === 'function') swat.initializeActionButtons();
      } catch (e) {}

      try {
        if (typeof swat.initializeActionButtonsOnProductGrid === 'function') swat.initializeActionButtonsOnProductGrid();
      } catch (e) {}

      fetchNostoWishlist();
      return true;
    }

    function initSwymProductCards(retryCount) {
      const buttons = document.querySelectorAll('.nosto-placements [data-action="wishlist-toggle"]');
      if (!buttons.length) return;

      if (runSwymActionButtonInitializers()) return;

      const attempts = retryCount || 0;
      if (attempts < 10) {
        window.setTimeout(() => initSwymProductCards(attempts + 1), 500);
      }

      window.Gazman = window.Gazman || {};
      if (!window.Gazman._nostoSwymCallbackQueued && Array.isArray(window.SwymCallbacks)) {
        window.Gazman._nostoSwymCallbackQueued = true;
        window.SwymCallbacks.push(() => {
          window.Gazman._nostoSwymCallbackQueued = false;
          initSwymProductCards();
        });
      }
    }

    function buildWishlistPageData(btn) {
      const ids = getWishlistButtonProductData(btn);
      const productUrl = btn.dataset.productUrl || '';
      return {
        epi: ids.variantId,
        empi: ids.productId,
        du: productUrl && productUrl.indexOf('http') !== 0 ? window.location.origin + productUrl : productUrl,
        dt: btn.dataset.productTitle || '',
        iu: btn.dataset.productImage || '',
        pr: Number(btn.dataset.productPrice) / 100,
        et: 4,
      };
    }

    function bindNostoWishlistFallback() {
      window.Gazman = window.Gazman || {};
      if (window.Gazman._nostoWishlistFallbackBound) return;
      window.Gazman._nostoWishlistFallbackBound = true;

      document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-action="wishlist-toggle"]');
        if (!btn || !btn.closest('.nosto-placements')) return;
        if (btn.classList.contains('swym-loaded')) return;

        const swat = window._swat;
        if (!swat) {
          initSwymProductCards();
          return;
        }

        e.preventDefault();
        e.stopImmediatePropagation();

        const pageData = buildWishlistPageData(btn);
        const shouldAdd = !isWishlistButtonAdded(btn);
        setWishlistButtonState(btn, shouldAdd);

        const onComplete = () => {
          fetchNostoWishlist();
          document.dispatchEvent(new CustomEvent('swym:wishlist-updated'));
        };

        if (shouldAdd) {
          swat.addToWishList(pageData, onComplete);
        } else {
          swat.removeFromWishList(pageData, onComplete);
        }
      }, true);
    }

    function initCarousels() {
      if (typeof Splide === 'undefined') return;
      document.querySelectorAll('[data-nosto-products-slider]').forEach((carouselEl) => {
        if (carouselEl._nostoSplideInitialized) return;
        const totalSlides = carouselEl.querySelectorAll('.splide__slide').length;
        if (totalSlides < 1) return;
        carouselEl._nostoSplideInitialized = true;

        if (totalSlides < 2) {
          carouselEl.classList.add('splide--single');
          markCarouselReady(carouselEl);
          return;
        }

        const perPage = parseInt(carouselEl.getAttribute('data-per-page'), 10) || 4;
        carouselEl._nostoSplide = new Splide(carouselEl, splideOptions(perPage, totalSlides));
        carouselEl._nostoSplide.mount();
        customiseArrowMarkup(carouselEl);
        markCarouselReady(carouselEl);
      });
    }

    function initLoadBindings() {
      document.querySelectorAll('[data-nosto-carousel-shell]').forEach(bindCampaignSettled);
    }

    function initNostoPlacements() {
      initLoadBindings();
      initCarousels();
      initSwymProductCards();
    }

    window.Gazman = window.Gazman || {};
    window.Gazman.initNostoPlacements = initNostoPlacements;
    window.Gazman.initSwymProductCards = initSwymProductCards;

    bindNostoWishlistFallback();
    document.addEventListener('@nosto/DynamicCard/loaded', initNostoPlacements);
    window.addEventListener('load', initNostoPlacements);
    initNostoPlacements();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-find-store"] && !Shopify.designMode) return;
  try {
    (function() {
  var stores = [];
  var storesLoaded = false;
  var autocomplete = null;
  var geometry = null;
  var initOptions = null;
  var popupEl = null;
  var initialized = false;
  var currentMode = null;
  var currentModalVariantId = null;
  var activeSearchToken = 0;

  // Store-hours disclosure glyph (matches live: plus when collapsed, minus when expanded).
  // Mirrors snippets/icon-plus.liquid + icon-minus.liquid (inlined because Liquid does not render inside javascript tags).
  var STORE_HOURS_ICON_PLUS = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" stroke-width="1.5"></line><line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" stroke-width="1.5"></line></svg>';
  var STORE_HOURS_ICON_MINUS = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" stroke-width="1.5"></line></svg>';

  // --- Helpers ---

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function formatMoney(cents) {
    if (window.Gazman && window.Gazman.formatMoneyForMarket) {
      return window.Gazman.formatMoneyForMarket(cents);
    }
    return window.Gazman && window.Gazman.formatMoney
      ? window.Gazman.formatMoney(cents)
      : '$' + (cents / 100).toFixed(2);
  }

  function haversineDistance(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = ((lat2 - lat1) * Math.PI) / 180;
    var dLon = ((lon2 - lon1) * Math.PI) / 180;
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  // --- Store Data ---

  function loadStores() {
    if (storesLoaded) return;
    const el = document.getElementById('stores-data-json');
    if (!el) return;
    try {
      stores = JSON.parse(el.textContent || '[]');
      storesLoaded = true;
    } catch (e) {
      stores = [];
    }
  }

  // --- Storefront API (for Click & Collect availability) ---

  function fetchStoreAvailability(variantId) {
    const isStaging = window.location.hostname.includes('gazman-stage');
    const token = isStaging
      ? '8f7a1a86788726cf485a01e0aa008303'
      : 'b10640454ab07b1ef64d5a4b1ed9ad24';

    return fetch('/api/2023-04/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: JSON.stringify({
        query: 'query { node(id: "gid://shopify/ProductVariant/' + variantId + '") { ... on ProductVariant { sku storeAvailability(first: 250) { edges { node { location { name } } } } } } }',
      }),
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.data && data.data.node && data.data.node.storeAvailability && data.data.node.storeAvailability.edges) {
        return data.data.node.storeAvailability.edges.map(function(e) {
          return e.node.location.name;
        });
      }
      return [];
    })
    .catch(function(err) {
      console.error('Error fetching store availability:', err);
      return [];
    });
  }

  // --- Stock Check (DotApparel API) ---

  function checkStock(variantId, variantList) {
    const isStaging = window.location.hostname.includes('gazman-stage');
    const token = isStaging
      ? '8f7a1a86788726cf485a01e0aa008303'
      : 'b10640454ab07b1ef64d5a4b1ed9ad24';

    let sku = '';

    return fetch('/api/2023-04/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: JSON.stringify({
        query: 'query { node(id: "gid://shopify/ProductVariant/' + variantId + '") { ... on ProductVariant { sku } } }',
      }),
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      sku = (data.data && data.data.node && data.data.node.sku) || '';
    })
    .catch(function() {
      // Fallback: find SKU from variants array
      if (variantList) {
        const v = variantList.find(function(v) { return v.id === variantId; });
        sku = (v && v.sku) || '';
      }
    })
    .then(function() {
      if (!sku) return null;

      return fetch('/apps/dotapparel/api-checkStock?sku=' + encodeURIComponent(sku))
        .then(function(res) {
          if (!res.ok) {
            throw new Error('Stock lookup failed with status ' + res.status);
          }
          return res.json();
        })
        .then(function(stock) { return Array.isArray(stock.data) ? stock.data : []; })
        .catch(function(err) {
          console.error('Error fetching store stock:', err);
          return null;
        });
    });
  }

  // --- Search & Results ---

  function getSizeSelect() {
    return popupEl ? qs('[data-find-store-size-select]', popupEl) : null;
  }

  function setSizeError(visible) {
    if (!popupEl) return;
    const errorEl = qs('[data-find-store-size-error]', popupEl);
    if (errorEl) errorEl.classList.toggle('hidden', !visible);
  }

  function cacheLocation(searchValue) {
    if (!geometry || !searchValue) return;
    try {
      localStorage.setItem('fis:geometry', JSON.stringify(geometry));
      localStorage.setItem('fis:search', searchValue);
    } catch (e) { /* ignore */ }
  }

  function restoreCachedLocation() {
    if (!popupEl) return;
    const input = qs('[data-find-store-search]', popupEl);
    if (!input) return;

    try {
      const cached = localStorage.getItem('fis:geometry');
      const cachedSearch = localStorage.getItem('fis:search');
      if (cached && cachedSearch) {
        geometry = JSON.parse(cached);
        input.value = cachedSearch;
      }
    } catch (e) { /* ignore */ }
  }

  function getReadableGeocodeLabel(results) {
    if (!results || !results.length) return 'Current Location';

    const preferred = results.find(function(result) {
      return result.types && result.types.indexOf('locality') > -1;
    }) || results.find(function(result) {
      return result.types && result.types.indexOf('postal_code') > -1;
    }) || results.find(function(result) {
      return result.types && result.types.indexOf('administrative_area_level_2') > -1;
    }) || results[0];

    return preferred.formatted_address || 'Current Location';
  }

  function getLocationLabel() {
    if (!geometry || !window.google || !window.google.maps || !window.google.maps.Geocoder) {
      return Promise.resolve('Current Location');
    }

    const geocoder = new window.google.maps.Geocoder();
    return new Promise(function(resolve) {
      geocoder.geocode({ location: geometry }, function(results, status) {
        if (status === 'OK') {
          resolve(getReadableGeocodeLabel(results));
        } else {
          resolve('Current Location');
        }
      });
    });
  }

  function applyGeolocationPosition(pos) {
    geometry = {
      lat: pos.coords.latitude,
      lng: pos.coords.longitude,
    };

    return getLocationLabel().then(function(locationLabel) {
      const input = qs('[data-find-store-search]', popupEl);
      if (input) {
        input.value = locationLabel;
        cacheLocation(input.value);
      }
      return performSearch();
    });
  }

  function resetSearchState() {
    activeSearchToken += 1;
    setSizeError(false);

    if (!popupEl) return;

    const resultsEl = qs('[data-find-store-results]', popupEl);
    const loadingEl = qs('[data-find-store-loading]', popupEl);
    const emptyEl = qs('[data-find-store-empty]', popupEl);
    const errorsEl = qs('[data-find-store-errors]', popupEl);

    if (resultsEl) resultsEl.innerHTML = '';
    if (loadingEl) loadingEl.classList.add('hidden');
    if (emptyEl) emptyEl.classList.add('hidden');
    if (errorsEl) {
      errorsEl.classList.add('hidden');
      const errorText = qs('p', errorsEl);
      if (errorText) errorText.textContent = '';
    }
  }

  function hasRequiredSizeSelection() {
    const sizeSelect = getSizeSelect();
    if (!sizeSelect) return true;
    return initOptions && initOptions.variantSelected && sizeSelect.value !== '';
  }

  function searchKnownLocation() {
    if (!geometry || !initOptions || !popupEl) return;
    if (!hasRequiredSizeSelection()) return;
    performSearch();
  }

  function notifyVariantSelection(variant) {
    if (!variant) return;
    document.dispatchEvent(new CustomEvent('find-store:variant-change', {
      detail: {
        variantId: variant.id,
      },
    }));
  }

  function performSearch() {
    if (!geometry || !initOptions || !popupEl) return Promise.resolve();

    const resultsEl = qs('[data-find-store-results]', popupEl);
    const loadingEl = qs('[data-find-store-loading]', popupEl);
    const emptyEl = qs('[data-find-store-empty]', popupEl);
    const errorsEl = qs('[data-find-store-errors]', popupEl);

    if (!resultsEl) return Promise.resolve();

    if (!hasRequiredSizeSelection()) {
      setSizeError(true);
      if (loadingEl) loadingEl.classList.add('hidden');
      if (emptyEl) emptyEl.classList.add('hidden');
      if (errorsEl) errorsEl.classList.add('hidden');
      resultsEl.innerHTML = '';
      return Promise.resolve();
    }

    setSizeError(false);

    // Show loading
    if (loadingEl) loadingEl.classList.remove('hidden');
    if (emptyEl) emptyEl.classList.add('hidden');
    if (errorsEl) errorsEl.classList.add('hidden');
    resultsEl.innerHTML = '';

    loadStores();

    activeSearchToken += 1;
    const searchToken = activeSearchToken;
    const searchOptions = initOptions;
    const isClickCollect = !!searchOptions.isClickCollect;
    const searchGeometry = {
      lat: geometry.lat,
      lng: geometry.lng,
    };
    const variant = searchOptions.currentVariant;
    if (!variant) {
      if (errorsEl) {
        errorsEl.classList.remove('hidden');
        const p = qs('p', errorsEl);
        if (p) p.textContent = 'Please select a variant before checking stock';
      }
      if (loadingEl) loadingEl.classList.add('hidden');
      return Promise.resolve();
    }

    // Fetch stock and availability in parallel
    return Promise.all([
      checkStock(variant.id, searchOptions.variants),
      isClickCollect ? fetchStoreAvailability(variant.id) : Promise.resolve([]),
    ])
    .then(function(results) {
      if (searchToken !== activeSearchToken) return;

      const stockData = results[0];
      const availableStoreNames = results[1];

      if (!Array.isArray(stockData)) {
        if (loadingEl) loadingEl.classList.add('hidden');
        if (errorsEl) {
          errorsEl.classList.remove('hidden');
          const p = qs('p', errorsEl);
          if (p) p.textContent = 'Unable to fetch store stock levels. Please try again';
        }
        return;
      }

      // Filter and sort stores
      let storeResults = stores
        .filter(function(s) { return s.lat && s.long && s.storeId; })
        .filter(function(s) {
          if (isClickCollect && availableStoreNames.length > 0) {
            return availableStoreNames.some(function(name) { return name === s.title; });
          }
          return true;
        })
        .map(function(s) {
          const stockEntry = stockData.find(function(d) {
            return d.attributes && d.attributes.storeId === Number(s.storeId);
          });
          return {
            id: s.id,
            storeId: s.storeId,
            title: s.title,
            address: s.address,
            suburb: s.suburb,
            state: s.state,
            postcode: s.postcode,
            lat: s.lat,
            long: s.long,
            phone: s.phone,
            email: s.email,
            link: s.link,
            hours: s.hours,
            distance: haversineDistance(
              Number(s.lat), Number(s.long),
              searchGeometry.lat, searchGeometry.lng
            ),
            stock: (stockEntry && stockEntry.attributes && stockEntry.attributes.freeStock) || 0,
          };
        })
        .filter(function(s) {
          if (isClickCollect) return s.stock > 0;
          return true;
        })
        .sort(function(a, b) {
          if (!isClickCollect) {
            const aHasStock = a.stock > 0;
            const bHasStock = b.stock > 0;
            if (aHasStock !== bHasStock) return aHasStock ? -1 : 1;
          }
          return a.distance - b.distance;
        })
        .slice(0, 10);

      if (loadingEl) loadingEl.classList.add('hidden');

      if (storeResults.length === 0) {
        if (emptyEl) emptyEl.classList.remove('hidden');
        return;
      }

      // Render results
      resultsEl.innerHTML = storeResults.map(function(store, i) {
        return renderStoreResult(store, i === storeResults.length - 1, isClickCollect, i);
      }).join('');

      // GTM tracking
      const searchInput = qs('[data-find-store-search]', popupEl);
      if (window.Gazman && window.Gazman.gtm && searchInput) {
        window.Gazman.gtm.trackFindAStore(searchInput.value || 'geolocation');
      }

      // Bind hours toggles
      qsa('[data-store-hours-toggle]', resultsEl).forEach(function(btn) {
        btn.addEventListener('click', function() {
          const panel = document.getElementById(btn.getAttribute('aria-controls'));
          if (panel && panel.hasAttribute('data-store-hours-panel')) {
            panel.classList.toggle('hidden');
            const expanded = !panel.classList.contains('hidden');
            btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            const iconEl = btn.querySelector('[data-store-hours-icon]');
            if (iconEl) iconEl.innerHTML = expanded ? STORE_HOURS_ICON_MINUS : STORE_HOURS_ICON_PLUS;
          }
        });
      });
    })
    .catch(function() {
      if (searchToken !== activeSearchToken) return;
      if (loadingEl) loadingEl.classList.add('hidden');
      if (errorsEl) {
        errorsEl.classList.remove('hidden');
        const p = qs('p', errorsEl);
        if (p) p.textContent = 'Something went wrong, please try again';
      }
    });
  }

  function renderStoreResult(store, isLast, isClickCollect, index) {
    const isCC = !!isClickCollect;
    const lowStockThreshold = 2;

    // Stock status
    let stockClass = 'text-dark-grey';
    let stockText = 'Out of stock';
    let stockIcon = 'icon-cross-circle';
    if ((store.stock > lowStockThreshold && !isCC) || store.stock >= 3) {
      stockClass = 'text-green';
      stockText = 'In stock';
      stockIcon = 'icon-check-circle';
    } else if (store.stock >= 1 && store.stock <= 2) {
      stockClass = 'text-orange';
      stockText = 'Low stock \u2014 call store to confirm';
      stockIcon = 'icon-exclamation-circle';
    }

    const distanceText = store.distance < 1
      ? Math.round(store.distance * 1000) + 'm'
      : store.distance.toFixed(1) + 'km';

    const mapsUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(store.address + ', ' + store.suburb + ', ' + store.state + ' ' + store.postcode);

    // Trading hours
    let hoursHtml = '';
    if (store.hours) {
      hoursHtml = store.hours
        .filter(function(h) { return h.hours; })
        .map(function(h) {
          return '<p class="w-full text-primary text-sm font-normal pb-0-4 flex items-center justify-between">' +
            '<span class="block capitalize md:w-1/3">' + h.label + '</span>' +
            '<span class="block md:w-2/3">' + h.hours + '</span>' +
            '</p>';
        })
        .join('');
    }

    // Stock icon SVG
    let stockIconSvg = '';
    if (stockIcon === 'icon-check-circle') {
      stockIconSvg = '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>';
    } else if (stockIcon === 'icon-exclamation-circle') {
      stockIconSvg = '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>';
    } else {
      stockIconSvg = '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"/>';
    }

    return '<div class="text-left py-2 min-h-48' + (!isLast ? ' border-b border-grey' : '') + '">' +
      '<div class="w-full flex items-stretch justify-between">' +
        '<div class="w-1/2 md:w-55 flex items-start justify-start pr-1">' +
          '<div class="flex-shrink-0 w-4 mr-1-5 text-brand"><svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 0C3.58 0 0 3.58 0 8c0 5.25 8 12 8 12s8-6.75 8-12c0-4.42-3.58-8-8-8zm0 11a3 3 0 110-6 3 3 0 010 6z" fill="currentColor"/></svg></div>' +
          '<div class="flex-1 flex flex-col">' +
            '<div class="flex flex-col md:flex-row items-start md:items-center justify-start">' +
              (store.link
                ? '<a href="' + store.link + '" class="text-md font-semibold underline text-primary">' + store.title + '</a>'
                : '<p class="text-md font-semibold text-primary">' + store.title + '</p>') +
              '<p class="text-left text-sm text-primary mt-1 md:mt-0 md:ml-1">' + distanceText + ' away</p>' +
            '</div>' +
            '<p class="text-sm text-primary mt-1">' + (store.address || '') + '<br />' + (store.suburb || '') + '<br />' + (store.state || '') + ' ' + (store.postcode || '') + '</p>' +
            '<a href="' + mapsUrl + '" target="_blank" rel="noopener" class="flex items-center justify-start mt-1 text-primary text-sm font-normal leading-normal">' +
              '<span class="block mr-0-7">Directions</span>' +
              '<span class="block w-4 mt-0-3"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
            '</a>' +
            '<button type="button" class="flex items-center h-auto justify-start text-primary text-sm font-normal leading-normal underline mt-0-2 p-0 focus:outline-none self-start" data-store-hours-toggle aria-expanded="false" aria-controls="store-hours-' + index + '">' +
              '<span class="block mr-0-5">Store Hours</span>' +
              '<span class="block w-4 mt-0-8" data-store-hours-icon>' + STORE_HOURS_ICON_PLUS + '</span>' +
            '</button>' +
          '</div>' +
        '</div>' +
        '<div class="w-1/2 md:w-2/5 pl-1 flex flex-col justify-between" style="padding-right:0.8rem">' +
          '<div>' +
            '<div class="mt-0-3 text-sm flex items-start justify-start ' + stockClass + '">' +
              '<div class="flex-shrink-0 w-3 mt-0-1 mr-0-5"><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">' + stockIconSvg + '</svg></div>' +
              '<div class="flex-1 text-sm"><p>' + stockText + '</p></div>' +
            '</div>' +
          '</div>' +
          '<div>' +
            (store.phone ? '<div class="text-primary text-sm flex justify-start h-7 xs:flex-col sm:flex-row xs:items-start sm:items-center"><p class="mr-0-4">Phone:</p><a href="tel:' + store.phone.replace(/\s/g, '') + '">' + store.phone + '</a></div>' : '') +
            (store.email ? '<div class="text-primary text-sm flex justify-start mt-1"><p class="mr-0-4">Email:</p><a href="mailto:' + store.email + '">' + store.email + '</a></div>' : '') +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div id="store-hours-' + index + '" class="hidden w-full mt-1" data-store-hours-panel>' +
        '<div class="flex items-start justify-start">' +
          '<div class="flex-shrink-0 w-4 mr-1-5"></div>' +
          '<div class="flex-1">' +
            '<p class="text-primary text-sm font-semibold mb-0-8 w-full">Trading Hours</p>' +
            hoursHtml +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  // --- Google Places Autocomplete ---

  function initAutocomplete() {
    if (!popupEl) return;
    const input = qs('[data-find-store-search]', popupEl);
    if (!input || !window.google || !window.google.maps || !window.google.maps.places) return;

    autocomplete = new window.google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: 'au' },
      types: ['geocode'],
    });

    autocomplete.addListener('place_changed', function() {
      const place = autocomplete.getPlace();
      if (place && place.geometry && place.geometry.location) {
        geometry = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
        cacheLocation(input.value);
        performSearch();
      }
    });

    restoreCachedLocation();
  }

  // --- Geolocation ---

  function initGeolocation() {
    if (!popupEl) return;
    const btn = qs('[data-find-store-geolocation]', popupEl);
    if (!btn) return;

    btn.addEventListener('click', function() {
      if (!navigator.geolocation) return;

      navigator.geolocation.getCurrentPosition(
        function(pos) {
          applyGeolocationPosition(pos);
        },
        function() {
          const errorsEl = qs('[data-find-store-errors]', popupEl);
          if (errorsEl) {
            errorsEl.classList.remove('hidden');
            const p = qs('p', errorsEl);
            if (p) p.textContent = 'Unable to get your location. Please search manually.';
          }
        }
      );
    });
  }

  // --- Size Selector ---

  function initSizeSelector() {
    if (!popupEl || !initOptions) return;
    const sel = getSizeSelect();
    if (!sel) return;

    sel.addEventListener('change', function() {
      const index = parseInt(sel.dataset.optionIndex || '1', 10);
      if (!sel.value) {
        initOptions.variantSelected = false;
        setSizeError(false);
        return;
      }

      // Find the matching variant
      const opts = {};
      if (initOptions.currentVariant) {
        opts.option1 = initOptions.currentVariant.option1;
        opts.option2 = initOptions.currentVariant.option2;
        opts.option3 = initOptions.currentVariant.option3;
      }
      opts['option' + index] = sel.value;

      const match = initOptions.variants.find(function(v) {
        return v.option1 === opts.option1 && v.option2 === opts.option2 && v.option3 === opts.option3;
      });

      if (match) {
        initOptions.currentVariant = match;
        initOptions.variantSelected = true;
        notifyVariantSelection(match);
        setSizeError(false);
        // Re-search if we have geometry
        if (geometry) performSearch();
      }
    });
  }

  function syncSizeSelectorState() {
    const sel = getSizeSelect();
    if (!sel || !initOptions) return;

    if (!initOptions.variantSelected) {
      sel.value = '';
      setSizeError(false);
      return;
    }

    const index = parseInt(sel.dataset.optionIndex || '1', 10);
    const variant = initOptions.currentVariant;
    if (variant && variant['option' + index]) {
      sel.value = variant['option' + index];
    }
  }

  // --- Public Init ---

  function init(popup, options) {
    popupEl = popup;
    initOptions = options;
    const nextMode = options.isClickCollect ? 'click-collect' : 'find-in-store';
    const nextVariantId = options.currentVariant && options.currentVariant.id;
    const shouldResetSearch = currentMode !== null && (
      currentMode !== nextMode || currentModalVariantId !== nextVariantId
    );

    currentMode = nextMode;
    currentModalVariantId = nextVariantId;

    if (shouldResetSearch) resetSearchState();

    // Show CC disclaimer if in click-collect mode
    const disclaimer = qs('[data-find-store-cc-disclaimer]', popup);
    if (disclaimer) {
      disclaimer.classList.toggle('hidden', !options.isClickCollect);
    }

    syncSizeSelectorState();

    restoreCachedLocation();

    if (initialized) {
      searchKnownLocation();
      return;
    }
    initialized = true;

    loadStores();
    initAutocomplete();
    initGeolocation();
    initSizeSelector();
    searchKnownLocation();

    // Form submit
    const form = qs('[data-find-store-form]', popup);
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        if (geometry) performSearch();
      });
    }

    // Search button (fallback)
    const submitBtn = qs('[data-find-store-submit]', popup);
    if (submitBtn) {
      submitBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (geometry) performSearch();
      });
    }

    // Mobile geolocation button
    const mobileGeoBtn = qs('[data-find-store-geolocation-mobile]', popup);
    if (mobileGeoBtn) {
      mobileGeoBtn.addEventListener('click', function() {
        if (!navigator.geolocation) return;
        navigator.geolocation.getCurrentPosition(
          function(pos) {
            applyGeolocationPosition(pos);
          },
          function() {
            const errorsEl = qs('[data-find-store-errors]', popupEl);
            if (errorsEl) {
              errorsEl.classList.remove('hidden');
              const p = qs('p', errorsEl);
              if (p) p.textContent = 'Unable to get your location. Please search manually.';
            }
          }
        );
      });
    }

    // Enter key in search
    const searchInput = qs('[data-find-store-search]', popup);
    if (searchInput) {
      searchInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (geometry) performSearch();
        }
      });
    }
  }

  document.addEventListener('find-store:init', function(e) {
    var d = e.detail;
    if (d && d.popup) {
      init(d.popup, {
        variants: d.variants,
        currentVariant: d.currentVariant,
        variantSelected: d.variantSelected,
        productMeta: d.productMeta,
        isClickCollect: d.isClickCollect,
      });
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snippet.dynamic-sections"] && !Shopify.designMode) return;
  try {
    (function() {
  /* ---------- Helper: Add to cart (delegates to centralized Gazman.addToCart) ---------- */

  function addToCart(variantId, quantity, productTags) {
    var properties = window.Gazman && window.Gazman.buildDiscountProperties
      ? window.Gazman.buildDiscountProperties(productTags || [])
      : null;
    return window.Gazman.addToCart(variantId, quantity || 1, properties || undefined);
  }

  function openCartDrawer() {
    document.dispatchEvent(new Event('cart:open'));
  }

  /* ---------- Hero Slider ---------- */

  function initHeroSliders(root) {
    (root || document).querySelectorAll('[data-hero-slider]').forEach(function(el) {
      if (el.classList.contains('is-initialized')) return;
      var showArrows = el.dataset.arrows !== 'false';
      var slideCount = el.querySelectorAll('.splide__slide').length;
      if (slideCount < 2) {
        // Single slide -- skip Splide but ensure content is visible
        el.classList.add('splide--single');
        return;
      }

      var splide = new Splide(el, {
        type: 'loop',
        autoplay: true,
        interval: 5000,
        pauseOnHover: true,
        pauseOnFocus: false,
        arrows: showArrows,
        pagination: true,
        speed: 600,
        perPage: 1,
        drag: true,
      });

      splide.on('moved', function() {
        // Pause videos on all slides, play on active
        el.querySelectorAll('.splide__slide video').forEach(function(v) {
          try { v.pause(); } catch (_e) { /* ignore */ }
        });
        var activeSlide = el.querySelector('.splide__slide.is-active');
        if (activeSlide) {
          activeSlide.querySelectorAll('video').forEach(function(v) {
            try { v.play(); } catch (_e) { /* ignore */ }
          });
        }
      });

      splide.mount();
    });
  }

  /* ---------- Featured Products Slider ---------- */

  function initFeaturedProductsSliders(root) {
    (root || document).querySelectorAll('[data-featured-products-slider]').forEach(function(el) {
      if (el.classList.contains('is-initialized')) return;
      var slideCount = el.querySelectorAll('.splide__slide').length;
      if (slideCount < 2 || typeof Splide === 'undefined') {
        // Fewer than 2 slides or Splide unavailable: reveal slides as a static
        // row rather than leaving the list collapsed (max-height: 0) and invisible.
        el.classList.add('splide--single');
        return;
      }

      try {
        el.classList.remove('splide--single');
        new Splide(el, {
          type: slideCount > 4 ? 'loop' : 'slide',
          perPage: 4,
          perMove: 1,
          gap: '0px',
          arrows: true,
          pagination: false,
          speed: 400,
          breakpoints: {
            1024: { perPage: 3 },
            768: { perPage: 2 },
            640: { perPage: 1, padding: { right: '35%' }, gap: '8px' },
          },
        }).mount();
      } catch (e) {
        el.classList.add('splide--single');
      }
    });
  }

  /* ---------- Featured Product (variant select + add to cart) ---------- */

  function initFeaturedProducts(root) {
    (root || document).querySelectorAll('[data-featured-product]').forEach(function(container) {
      if (container.dataset.dsInit) return;
      container.dataset.dsInit = '1';
      var variantSelect = container.querySelector('[data-featured-variant-select]');
      var variantIdInput = container.querySelector('[data-featured-variant-id]');
      var addBtn = container.querySelector('[data-featured-add-to-cart]');

      if (!addBtn || !variantIdInput) return;

      if (variantSelect) {
        variantSelect.addEventListener('change', function() {
          variantIdInput.value = variantSelect.value;
        });
      }

      addBtn.addEventListener('click', function() {
        var variantId = parseInt(variantIdInput.value, 10);
        if (!variantId) return;

        var addText = addBtn.querySelector('[data-add-text]');
        var addingText = addBtn.querySelector('[data-adding-text]');
        var addedText = addBtn.querySelector('[data-added-text]');

        addBtn.disabled = true;
        if (addText) addText.classList.add('hidden');
        if (addingText) addingText.classList.remove('hidden');

        var productTags = [];
        try {
          var productJson = container.getAttribute('data-product-json');
          if (productJson) productTags = (JSON.parse(productJson) || {}).tags || [];
        } catch (e) { /* ignore */ }

        addToCart(variantId, 1, productTags).then(function() {
          if (addingText) addingText.classList.add('hidden');
          if (addedText) addedText.classList.remove('hidden');
          openCartDrawer();

          setTimeout(function() {
            addBtn.disabled = false;
            if (addedText) addedText.classList.add('hidden');
            if (addText) addText.classList.remove('hidden');
          }, 2000);
        }).catch(function() {
          addBtn.disabled = false;
          if (addingText) addingText.classList.add('hidden');
          if (addText) addText.classList.remove('hidden');
        });
      });
    });
  }

  /* ---------- Gallery Slider ---------- */

  function initGallerySliders(root) {
    (root || document).querySelectorAll('[data-gallery-slider]').forEach(function(el) {
      if (el.classList.contains('is-initialized')) return;
      var perPage = parseInt(el.dataset.perPage || '3', 10);
      var slideCount = el.querySelectorAll('.splide__slide').length;
      if (slideCount < 2 || typeof Splide === 'undefined') {
        el.classList.add('splide--single');
        return;
      }

      try {
        el.classList.remove('splide--single');
        new Splide(el, {
          type: slideCount > perPage ? 'loop' : 'slide',
          perPage: perPage,
          perMove: 1,
          gap: '0.5rem',
          arrows: true,
          pagination: true,
          speed: 400,
          breakpoints: {
            768: { perPage: 1 },
          },
        }).mount();
      } catch (e) {
        el.classList.add('splide--single');
      }
    });
  }

  /* ---------- Collection Template Mobile Slider ---------- */

  function initCollectionTemplateSliders(root) {
    (root || document).querySelectorAll('[data-collection-template-slider]').forEach(function(el) {
      if (el.classList.contains('is-initialized')) return;
      var slideCount = el.querySelectorAll('.splide__slide').length;
      if (slideCount < 2 || typeof Splide === 'undefined') {
        el.classList.add('splide--single');
        return;
      }

      try {
        el.classList.remove('splide--single');
        new Splide(el, {
          type: 'slide',
          perPage: 2,
          perMove: 1,
          gap: '0.5rem',
          arrows: false,
          pagination: true,
          speed: 400,
        }).mount();
      } catch (e) {
        el.classList.add('splide--single');
      }
    });
  }

  /* ---------- Shop the Look ---------- */

  function initShopTheLook(root) {
    (root || document).querySelectorAll('[data-section-type="shop-the-look"]').forEach(function(section) {
      if (section.dataset.dsInit) return;
      section.dataset.dsInit = '1';
      var imageSliderEl = section.querySelector('[data-shop-look-images]');
      var productSliderEl = section.querySelector('[data-shop-look-products]');
      if (!imageSliderEl || !productSliderEl) return;

      var imageSlides = imageSliderEl.querySelectorAll('.splide__slide');
      var productSlides = productSliderEl.querySelectorAll('.splide__slide');
      if (imageSlides.length < 1) return;

      // Build look ID map
      var lookIds = [];
      imageSlides.forEach(function(slide) {
        var lookId = slide.dataset.lookId || '';
        if (lookId && lookIds.indexOf(lookId) === -1) {
          lookIds.push(lookId);
        }
      });

      // Filter products when image slide changes
      function filterProducts(lookId) {
        productSlides.forEach(function(slide) {
          var slideLookId = slide.dataset.lookId || '';
          if (slideLookId === lookId) {
            slide.style.display = '';
          } else {
            slide.style.display = 'none';
          }
        });
      }

      // Init image slider
      var imageSplide = new Splide(imageSliderEl, {
        type: imageSlides.length > 1 ? 'loop' : 'slide',
        perPage: 1,
        arrows: imageSlides.length > 1,
        pagination: imageSlides.length > 1,
        speed: 400,
      });

      imageSplide.on('moved', function(newIndex) {
        var activeSlide = imageSlides[newIndex];
        if (activeSlide) {
          filterProducts(activeSlide.dataset.lookId || '');
        }
      });

      imageSplide.mount();

      // Init product slider
      new Splide(productSliderEl, {
        type: 'slide',
        perPage: 2,
        perMove: 1,
        gap: '0px',
        arrows: true,
        pagination: false,
        speed: 400,
        breakpoints: {
          768: { perPage: 2 },
        },
      }).mount();

      // Initial filter
      if (lookIds.length > 0) {
        filterProducts(lookIds[0]);
      }
    });
  }

  /* ---------- Mix & Match ---------- */

  function initMixMatch(root) {
    (root || document).querySelectorAll('[data-section-type="mix-match"]').forEach(function(section) {
      if (section.dataset.dsInit) return;
      section.dataset.dsInit = '1';
      var topSliderEl = section.querySelector('[data-mix-match-slider="top"]');
      var bottomSliderEl = section.querySelector('[data-mix-match-slider="bottom"]');
      var addBtn = section.querySelector('[data-mix-match-add]');

      var topSplide = null;
      var bottomSplide = null;

      // Init top slider
      if (topSliderEl) {
        var slideCount = topSliderEl.querySelectorAll('.splide__slide').length;
        if (slideCount > 1) {
          var direction = topSliderEl.dataset.direction;
          topSplide = new Splide(topSliderEl, {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            focus: 'center',
            gap: '0px',
            arrows: true,
            pagination: false,
            speed: 400,
            autoplay: direction !== 'off',
            interval: 3000,
            direction: direction === 'left' ? 'rtl' : 'ltr',
            breakpoints: {
              768: { perPage: 2 },
            },
          });
          topSplide.mount();
        }
      }

      // Init bottom slider
      if (bottomSliderEl) {
        var slideCount = bottomSliderEl.querySelectorAll('.splide__slide').length;
        if (slideCount > 1) {
          var direction = bottomSliderEl.dataset.direction;
          bottomSplide = new Splide(bottomSliderEl, {
            type: 'loop',
            perPage: 3,
            perMove: 1,
            focus: 'center',
            gap: '0px',
            arrows: true,
            pagination: false,
            speed: 400,
            autoplay: direction !== 'off',
            interval: 3000,
            direction: direction === 'left' ? 'rtl' : 'ltr',
            breakpoints: {
              768: { perPage: 2 },
            },
          });
          bottomSplide.mount();
        }
      }

      // Add both to cart
      if (addBtn) {
        addBtn.addEventListener('click', function() {
          var addText = addBtn.querySelector('[data-add-text]');
          var addingText = addBtn.querySelector('[data-adding-text]');
          var addedText = addBtn.querySelector('[data-added-text]');

          addBtn.disabled = true;
          if (addText) addText.classList.add('hidden');
          if (addingText) addingText.classList.remove('hidden');

          // Get active slides from both carousels
          var topActive = topSliderEl ? topSliderEl.querySelector('.splide__slide.is-active') : null;
          var bottomActive = bottomSliderEl ? bottomSliderEl.querySelector('.splide__slide.is-active') : null;

          var items = [];

          if (topActive) {
            var json = topActive.getAttribute('data-product-json');
            if (json) {
              var product = JSON.parse(json);
              var variant = (product.variants && product.variants[0]) || product.selected_or_first_available_variant;
              if (variant && variant.id) items.push({ id: variant.id, quantity: 1, tags: product.tags || [] });
            }
          }

          if (bottomActive) {
            var json = bottomActive.getAttribute('data-product-json');
            if (json) {
              var product = JSON.parse(json);
              var variant = (product.variants && product.variants[0]) || product.selected_or_first_available_variant;
              if (variant && variant.id) items.push({ id: variant.id, quantity: 1, tags: product.tags || [] });
            }
          }

          // Add items sequentially
          var promise = Promise.resolve();
          items.forEach(function(item) {
            promise = promise.then(function() {
              return addToCart(item.id, item.quantity, item.tags);
            });
          });

          promise.then(function() {
            if (addingText) addingText.classList.add('hidden');
            if (addedText) addedText.classList.remove('hidden');
            openCartDrawer();

            setTimeout(function() {
              addBtn.disabled = false;
              if (addedText) addedText.classList.add('hidden');
              if (addText) addText.classList.remove('hidden');
            }, 2000);
          }).catch(function() {
            addBtn.disabled = false;
            if (addingText) addingText.classList.add('hidden');
            if (addText) addText.classList.remove('hidden');
          });
        });
      }
    });
  }

  /* ---------- Init ---------- */

  function init(root) {
    initHeroSliders(root);
    initFeaturedProductsSliders(root);
    initFeaturedProducts(root);
    initGallerySliders(root);
    initCollectionTemplateSliders(root);
    initShopTheLook(root);
    initMixMatch(root);
  }

  // Run init across several lifecycle points. Every initialiser is idempotent
  // (Splide sliders skip when already `.is-initialized`; other initialisers use
  // a `data-ds-init` flag), so re-running is safe and never double-mounts.
  // The extra passes guard against the first pass missing a slider when Splide
  // or the section markup is not ready at DOMContentLoaded -- the failure mode
  // that leaves a carousel collapsed (max-height: 0) and invisible.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(); });
  } else {
    init();
  }
  window.addEventListener('load', function() { init(); });
  setTimeout(function() { init(); }, 1200);

  // Theme editor: re-init when a section is re-rendered, otherwise Splide-based
  // sections (hero, etc.) appear blank until saved.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      init(e.target);
    });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snippet.gazman-core"] && !Shopify.designMode) return;
  try {
    // --- Format (formatMoney) ---
(function() {
  function formatMoney(cents, format) {
    var moneyFormat = format || (window.Gazman && window.Gazman.moneyFormat);
    if (!moneyFormat) return '$' + (cents / 100).toFixed(2);

    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = moneyFormat;

    function addCommas(n) {
      return n.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }

    function floatToString(num, decimals) {
      var power = Math.pow(10, decimals);
      var str = String((Math.round(num * power) / power).toFixed(decimals));
      return str;
    }

    var value = '';
    var match = formatString.match(placeholderRegex);
    if (!match) return formatString;

    switch (match[1]) {
      case 'amount':
        value = addCommas(floatToString(cents / 100, 2));
        break;
      case 'amount_no_decimals':
        value = addCommas(floatToString(cents / 100, 0));
        break;
      case 'amount_with_comma_separator':
        value = floatToString(cents / 100, 2).replace(/\./, ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = addCommas(floatToString(cents / 100, 0)).replace(/\./, ',');
        break;
      default:
        value = addCommas(floatToString(cents / 100, 2));
    }

    return formatString.replace(placeholderRegex, value);
  }

  // Market-aware: prefix the active presentment currency code on non-base
  // markets (e.g. NZ -> "NZD $129"), matching snippets/price.liquid. Base
  // market (AU) stays unprefixed unless showCurrencyForBase is set.
  function formatMoneyForMarket(cents, format) {
    var formatted = formatMoney(cents, format);
    var g = window.Gazman || {};
    var currency = g.currencyCode;
    var base = g.baseCurrencyCode;
    if (!currency) return formatted;
    if (currency === base && !g.showCurrencyForBase) return formatted;
    return currency + ' ' + formatted;
  }

  // Market-aware flag parsing (Task 801). Given a flag tag with the leading
  // 'flag:' already removed, decides whether it renders for the buyer's market
  // and returns the display text with any market prefix stripped:
  //   "AU:2 for $99" -> { show: <buyer is AU>, text: "2 for $99" }
  //   "NEW ARRIVAL"  -> { show: true, text: "NEW ARRIVAL" }  (no market prefix)
  // A "XX:" prefix only counts as a market when XX is a configured market
  // country, so a non-market value is never hidden.
  function parseFlag(raw) {
    var m = /^([A-Z]{2}):([\s\S]*)$/.exec(raw);
    if (!m) return { show: true, text: raw };
    var markets = (window.Gazman && window.Gazman.marketCountryCodes) || [];
    if (markets.indexOf(m[1]) === -1) return { show: true, text: raw };
    return { show: m[1] === (window.Gazman && window.Gazman.countryCode), text: m[2] };
  }

  window.Gazman = window.Gazman || {};
  window.Gazman.formatMoney = formatMoney;
  window.Gazman.formatMoneyForMarket = formatMoneyForMarket;
  window.Gazman.parseFlag = parseFlag;
})();

// --- Member discount (line-item properties for Shopify Scripts) ---
(function() {
  window.Gazman = window.Gazman || {};

  var cfg = null;
  var el = document.getElementById('gazman-discount-config-json');
  if (el) {
    try { cfg = JSON.parse(el.textContent || ''); } catch (e) { cfg = null; }
  }

  window.Gazman.buildDiscountProperties = function(productTags) {
    if (!cfg || !cfg.tag) return null;
    if (!productTags || !productTags.length) return null;
    var tags = Array.isArray(productTags) ? productTags : String(productTags).split(',');
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).trim() === cfg.tag) {
        return {
          _discount_amount: cfg.amount,
          _discount_name: cfg.label,
          _customer_tag: cfg.customer_tag,
        };
      }
    }
    return null;
  };
})();

// --- Add to Cart (centralized, with bundled section rendering) ---
(function() {
  window.Gazman = window.Gazman || {};

  window.Gazman.addToCart = function(variantId, quantity, properties) {
    return fetch((window.Gazman.routeRoot || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity || 1,
        properties: properties || {},
        sections: 'cart-drawer',
      }),
    })
    .then(function(res) {
      if (!res.ok) return res.text().then(function(t) {
        var msg = res.statusText;
        try { msg = JSON.parse(t).description || msg; } catch(e) {}
        throw new Error(msg);
      });
      return res.json();
    })
    .then(function(addResponse) {
      // Open + render the drawer immediately from the section the add request
      // already returned, instead of blocking on a second /cart.js round-trip.
      var cart = { sections: addResponse.sections, _showItemAddedLabel: true };
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

      // Reconcile the header cart badge total in the background (non-blocking).
      fetch((window.Gazman.routeRoot || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function(res) { return res.json(); })
        .then(function(full) {
          document.dispatchEvent(new CustomEvent('cart:reconcile', { detail: full }));
        })
        .catch(function() {});

      return cart;
    });
  };
})();

// --- GTM (Google Tag Manager) ---
(function() {
  function push(data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }

  function getCurrency() {
    return (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.currency) || 'AUD';
  }

  function trackAddToCart(product, variant, quantity, collection) {
    var colour = product?.tags?.find(function(tag) { return tag.startsWith('x-colour:'); })?.split(':')?.[1];
    var sale = variant.compare_at_price > variant.price ? 'Sale' : '';
    var discount = product.tags?.find(function(tag) { return tag.indexOf('flag:') >= 0; });
    if (discount) {
      // Strip any leading market prefix (e.g. "AU:") so GTM reports "2 for $99".
      var offer = discount.split('flag:')[1].replace(/^[A-Z]{2}:/, '');
      sale = sale ? sale + ' | ' + offer : offer;
    }

    var list = collection || 'Product Details';

    push({
      event: 'addToCart',
      ecommerce: {
        currencyCode: getCurrency(),
        add: {
          actionField: { list: list },
          products: [
            {
              name: product.title.replace("'", ''),
              id: variant.sku,
              price: variant.price / 100,
              brand: product.vendor,
              variant: colour,
              quantity: quantity,
              dimension11: variant?.title?.replace("'", ''),
              dimension12: variant?.available ? 'In Stock' : 'Out of Stock',
              dimension13: sale || '',
              category: collection || product?.product_type,
            },
          ],
        },
      },
    });
  }

  function trackRemoveFromCart(lineitem) {
    var colour = lineitem?.tags?.find(function(tag) { return tag.startsWith('x-colour:'); })?.split(':')?.[1];
    var selected = lineitem.variants?.find(function(v) { return v.selected; });

    push({
      event: 'remove',
      ecommerce: {
        remove: {
          products: [
            {
              id: lineitem.sku,
              name: lineitem.product_title,
              quantity: lineitem.quantity,
              price: lineitem.price / 100,
              brand: lineitem.vendor,
              variant: colour,
              dimension11: lineitem.variant_title,
              dimension12: selected?.available ? 'In Stock' : 'Out of Stock',
            },
          ],
        },
      },
    });
  }

  function trackProductDetail(product, currencyCode, list) {
    push({
      event: 'productDetail',
      ecommerce: {
        currencyCode: currencyCode,
        detail: {
          actionField: { list: list },
          products: [product],
        },
      },
    });
  }

  function trackImpression(product, currencyCode, list) {
    push({
      event: 'impressionsPushed',
      ecommerce: {
        actionField: { list: list },
        currencyCode: currencyCode,
        impressions: [product],
      },
    });
  }

  function trackProductClick(product, currencyCode, list) {
    push({
      event: 'productClick',
      ecommerce: {
        currencyCode: currencyCode,
        click: {
          actionField: { list: list },
          products: [product],
        },
      },
    });
  }

  function trackSignUp() {
    push({
      event: 'signUp',
      eventCategory: 'Sign Up',
      eventAction: 'Create Account',
      userId: '',
    });
  }

  function trackSocial(network, url) {
    push({
      event: 'social',
      socialNetwork: network,
      socialAction: 'View',
      socialTarget: '<target ' + url + '>',
    });
  }

  function trackZeroSearchResult(keyword) {
    push({
      event: 'zeroSearch',
      eventCategory: 'Error',
      eventAction: '0 Search Results',
      eventLabel: keyword,
    });
  }

  function trackFindAStore(location) {
    push({
      event: 'find',
      eventCategory: 'Find a Store',
      eventAction: 'Store Search',
      eventLabel: location,
    });
  }

  function trackPromotionImpressions(promotions) {
    push({
      ecommerce: {
        promoView: {
          promotions: promotions,
        },
      },
    });
  }

  function trackPromotionClick(promotions) {
    push({
      event: 'promotionClick',
      ecommerce: {
        promoClick: {
          promotions: promotions,
        },
      },
    });
  }

  window.Gazman = window.Gazman || {};
  window.Gazman.gtm = {
    trackAddToCart: trackAddToCart,
    trackRemoveFromCart: trackRemoveFromCart,
    trackProductDetail: trackProductDetail,
    trackImpression: trackImpression,
    trackProductClick: trackProductClick,
    trackSignUp: trackSignUp,
    trackSocial: trackSocial,
    trackZeroSearchResult: trackZeroSearchResult,
    trackFindAStore: trackFindAStore,
    trackPromotionImpressions: trackPromotionImpressions,
    trackPromotionClick: trackPromotionClick,
  };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-header"] && !Shopify.designMode) return;
  try {
    (function() {
  function updateHeaderWishlist() {
    var swat = window._swat;
    if (!swat) return;

    swat.fetch(function(products) {
      var count = products.length;
      var icons = document.querySelectorAll('.js-wishlist-icon');
      var filledIcons = document.querySelectorAll('.js-wishlist-icon-filled');
      var counts = document.querySelectorAll('.js-wishlist-count');

      if (count > 0) {
        icons.forEach(function(el) { el.classList.add('hidden'); });
        filledIcons.forEach(function(el) { el.classList.remove('hidden'); });
        counts.forEach(function(el) {
          el.textContent = String(count);
          el.classList.remove('hidden');
        });
      } else {
        icons.forEach(function(el) { el.classList.remove('hidden'); });
        filledIcons.forEach(function(el) { el.classList.add('hidden'); });
        counts.forEach(function(el) {
          el.textContent = '';
          el.classList.add('hidden');
        });
      }
    });
  }

  function init() {
    // Listen for wishlist changes (dispatched by product.ts and Swym)
    document.addEventListener('swym:wishlist-updated', updateHeaderWishlist);

    // Hook into SWYM native events so header count updates
    // even when SWYM handles the click (modal flow) instead of our fallback JS
    var swymEvtBound = false;
    function bindSwymEvents() {
      var swat = window._swat;
      if (!swat || !swat.evtLayer || swymEvtBound) return;
      swymEvtBound = true;
      swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, function() {
        updateHeaderWishlist();
      });
      swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, function() {
        updateHeaderWishlist();
      });
    }

    // Initial check with retry (Swym loads async)
    var tryInit = function() {
      if (window._swat) {
        updateHeaderWishlist();
        bindSwymEvents();
      } else {
        setTimeout(tryInit, 1000);
      }
    };
    tryInit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
